import { Accordion, type AccordionItemProps, type AccordionProps, MarkDown } from "@wayflyer/flyui";

export type AccordionGroupItem = {
  title: string;
  body?: string;
};

export interface AccordionGroupProps extends Pick<AccordionProps, "showFinalDivider" | "inverse"> {
  items: ({ item: AccordionGroupItem } & Pick<AccordionItemProps, "initiallyExpanded">)[];
}

export const AccordionGroup = ({ items, showFinalDivider = false }: AccordionGroupProps) => {
  return (
    <Accordion
      showFinalDivider={showFinalDivider}
      items={items.map(({ item, initiallyExpanded }) => {
        return {
          header: item.title,
          body: item.body ? <MarkDown markdown={item.body} /> : null,
          initiallyExpanded,
        };
      })}
    />
  );
};
